import { ElementsFactories } from 'react-planner';

const info = {
  title: 'Gas Pipe',
  tag: ['pipe'],
  description: 'Gas Pipe',
  image: require('./pipe.png'),
  visibility: {
    catalog: true,
    layerElementsVisible: true
  }
};

export default ElementsFactories.PipeFactoryGas('gas-pipe', info, null);

